import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import styles from './CanvasControls.css';

/**
 * Show the controls for interacting with Canvas pane preview
 * @param {object} props - object
 * @returns {React.Component} styled preview pane
 */
const CanvasControls = props => (
  <div
    className={classnames(
      'd-inline-flex justify-content-center align-items-center m-0',
      'bg-white border-bottom border-secondary',
      styles.wrapper,
      props.fullscreenStyles
    )}
  >
    {props.children}
  </div>
);

CanvasControls.propTypes = {
  children: propTypes.node.isRequired,
  fullscreenStyles: propTypes.string
};

CanvasControls.defaultProps = {
  fullscreenStyles: ''
};

export default CanvasControls;
